'use client';

import { animated } from '@react-spring/web';
import Link from 'next/link';
import { HelpTitle } from '../help-title';
import { useSpringCount } from '@ssv-website/hooks';
// import useSpringCount from '@ssv-website/hooks/useSpringCount'

export interface IAbilityCounterProps {
  count: number;
  title: string;
  desc?: string;
  link?: string;
  help?: string;
  onlyTitle?: boolean;
  unit?: string;
}

export interface ISpanCounterProps {
  value: number;
  className?: string;
}

export const SpanCounter: React.FC<ISpanCounterProps> = ({
  value = 0,
  ...rest
}) => {
  const { animatedRef, count } = useSpringCount(value);
  return (
    <animated.span
      ref={animatedRef}
      className="font-tcn font-300 text-5xl text-tcn leading-[50px] text-primary mb-[3px]"
      {...rest}
    >
      {count}
    </animated.span>
  );
};

export const AbilityCounter: React.FC<IAbilityCounterProps> = ({
  count,
  title,
  link,
  help,
  onlyTitle,
  unit,
}) => {
  return (
    <div className="flex-1 flex items-center pointer-events-auto">
      <div className="h-[90px] border-l border-solid border-primary/[.16] mr-5 mobile:h-[58px]" />
      <div className="relative w-full h-24 flex flex-col justify-between mobile:h-[58px]">
        <Link href={link ?? ''}>
          <SpanCounter
            value={count}
            className="font-tcn font-300 text-5xl text-tcn text-tcn1 leading-[50px] text-primary mb-[3px] mobile:text-2xl mobile:mb-[10px] mobile:leading-[34px]"
          />
          {unit && (
            <span className="font-tcn font-300 text-5xl text-tcn leading-[50px] text-primary mobile:text-2xl mobile:leading-[34px]">
              {unit}
            </span>
          )}
        </Link>
        <HelpTitle onlyTitle={onlyTitle} title={title} help={help} />
      </div>
    </div>
  );
};
